import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { AssetsService, SponsorAssetFile } from '../../infrastructure/services/assets.service';
import { LoaderService } from '../../infrastructure/services/loader.service';
import { FileImagen } from '../../helpers/components/fileUpload/imageUploader.component';
import { Translator } from 'angular-translator';
import { DesignerCachableOutput } from '../sxfdesigner/types/designer-context-type';
import { CacheService } from 'app/infrastructure/services/cache.service';

@Component({
  templateUrl: 'detalle.assetFile.component.html'
})
export class DetalleAssetFileComponent implements OnInit {
  codSistema: string;
  codNegocio: string;
  codSponsor: string;
  codProducto: string;
  idAsset: string;
  codAsset: string;
  esNuevoAsset: boolean;
  esNuevo: boolean;
  asset: SponsorAssetFile;
  errores = {
    assetContent: null,
    codAsset: null,
  };

  isDesignerCreated = false;
  designerContext: DesignerCachableOutput;

  constructor(private aRoute: ActivatedRoute,
    private router: Router,
    private assetsService: AssetsService,
    private translator: Translator,
    private location: Location,
    private cacheService: CacheService,
    public loader: LoaderService) { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codSponsor = null;
      this.codProducto = params['codproducto'];
      this.idAsset = params['idAsset'];
      this.codAsset = params['codAsset'];

      this.esNuevoAsset = false;

      if (this.codAsset === 'nuevo') {
        this.codAsset = '';
        this.esNuevoAsset = true;
      }

      this.esNuevo = false;

      // Si estoy creando un nuevo Asset
      if (this.idAsset === 'nuevo') {
        this.esNuevo = true;

        this.asset = {
          codAsset: this.codAsset,
          codInstalacionV5: this.codSistema,
          codNegocio: this.codNegocio,
          codSponsor: this.codSponsor,
          codProducto: this.codProducto,
          assetContent: null,
          assetContentType: null,
          fileName: '',
          fileExtension: null,
          assetSize: null,
          descripcion: '',
        };


        this.designerContext = this.cacheService.getDesignerOutputs();
        if (!this.designerContext) {
          this.isDesignerCreated = false;
        } else {
          this.isDesignerCreated = true;
        }

        return;
      }

      // Si estoy editando un asset existente
      this.assetsService
        .getAssetFileById(this.codSistema, this.codNegocio, this.codSponsor, this.idAsset)
        .then(res => this.asset = res);
    });
  }

  guardar() {
    if (this.datosValidos()) {
      this.assetsService.crearAssetFile(this.asset)
        .then((_) => {
          if (this.isDesignerCreated) {
            // the outputs are not needed, so they need to go away as well
            this.cacheService.removeDesignerOutputs();

            if (this.designerContext.storedContext.listPath) {
              this.router.navigate(['../../../../Flow',this.designerContext.storedContext.documentKind,
              this.designerContext.storedContext.flowId,
               'sxfDesigner', this.designerContext.storedContext.pageId,
                this.designerContext.storedContext.listPath],
                { relativeTo: this.aRoute });
            } else {
              this.router.navigate(['../../../../Flow',this.designerContext.storedContext.documentKind,
              this.designerContext.storedContext.flowId, 'sxfDesigner', this.designerContext.storedContext.pageId],
                { relativeTo: this.aRoute });
            }
          } else {
            this.volverAlListado.bind(this);
          }
        });
    }
  }

  editar() {
    if (this.datosValidos()) {
      this.assetsService.editarAssetFile(this.idAsset, this.asset)
        .then(this.volverAlListado.bind(this));
    }
  }

  imagenCambiada(file: FileImagen) {
    this.asset.assetContent = file.imagenBase64;
    this.asset.assetContentType = file.type;
    this.asset.fileExtension = file.extension;
    this.asset.fileName = file.name;
    this.asset.assetSize = file.size;
  }

  private datosValidos() {
    let esValido = true;

    // reseteo los errores antes de checkear nuevamente
    this.resetearErrores();

    if (this.asset.assetContent === null) {
      this.errores['assetContent'] = <string>this.translator.instant('VALOR_REQUERIDO');
      esValido = false;
    }

    if (this.asset.codAsset === null || this.asset.codAsset.length <= 0) {
      this.errores['codAsset'] = <string>this.translator.instant('VALOR_REQUERIDO');
      esValido = false;
    }

    return esValido;
  }

  private resetearErrores() {
    Object.keys(this.errores).forEach(key => this.errores[key] = null);
  }

  private volverAlListado() {
    this.router.navigate(['../../../'], { relativeTo: this.aRoute });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/assets/detalle.assetFile.component.ts